import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl/dist';

// Components

import AlertInfo from '../../../components/common/alert/AlertInfo';
import PageHeader from '../headers/PageHeader';
import SummaryItem from './pageIncludes/summary/SummaryItem';
import SourcesSummary from './pageIncludes/summary/summaryIncludes/SourcesSummary';

// Utils

import { currencyTools } from '../../../utils/tools/currencyTools';
import { helperFunctions } from '../../../utils/tools/helperFunctions';
import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';


const Page3_36_E1 = props => {

    const {
        data,
        data: {
            coverageYear
        },
        environment: {
            isState
        }
    } = props;

    const {
        buttonContainer: ButtonContainer,
        currentHhm,
        hhmIndex,
        itfFeatureEnabled
    } = props;

    const {
        annualTaxIncome: {
            projectedIncome,
            reportedIncome
        },
        applicantGuid,
        incomes = [],
        expenses = [],
        name,
        monthlyReportedIncome,
        taxHouseholdComposition: {
            independentTaxFiler
        }
    } = currentHhm;

    const monthlyIncome = currencyTools.getMoneyFormat(monthlyReportedIncome, true) ;

    const getAlert = () => {
        switch (true) {
            case isState.NJ:
                return (
                    <AlertInfo
                        { ...{
                            id: 'ssap.income_information.summary.calculation',
                            shouldParse: true,
                            textReplacements: { monthlyIncome }
                        } }
                    />
                );
            default:
                // TODO: refactor it to use AlertInfo
                return (
                    <div className="usa-alert usa-alert--info gi-alert gi-alert__info">
                        <div className="usa-alert__body gi-alert__info__body">
                            <p className="usa-alert__text gi-alert__info__text">
                                <FormattedMessage
                                    id='ssap.income_information.summary.calculation'
                                    values = {{
                                        monthlyIncome: (
                                            <Fragment>
                                                <br/>
                                                { monthlyIncome }
                                                <br/>
                                            </Fragment>
                                        )
                                    }}
                                />
                                <br/>
                                <br/>
                                {
                                    isState.NJ &&
                                    <FormattedMessage id = 'ssap.income_information.summary.make_sure'/>
                                }
                            </p>
                            {
                                itfFeatureEnabled && independentTaxFiler &&

                                <FormattedMessage
                                    id = 'ssap.income_information.summary.independent_tax_filer'
                                    values= {{ independentTaxFilerName: <b>{ normalizeNameOfPerson(name) }</b> }}
                                />
                            }
                        </div>
                    </div>
                );
        }
    };

    return (
        <Fragment>
            <div id="individualIncomeSummary">
                <div className="subsection">

                    <div className='summary__block margin-b-20' key={name.firstName}>
                        <div className="usa-grid usa-width-one-whole summary__header">
                            <PageHeader
                                text='ssap.subheader.persons_income_summary'
                                textReplacements={{
                                    personName: normalizeNameOfPerson(name)
                                }}
                                headerClassName={'gi-heading-alt'}
                                additionalElement={(
                                    <ButtonContainer
                                        type="editButton_secondary"
                                        args={[hhmIndex]}
                                    />
                                )}
                                additionalElementClassName={'header-btn'}
                            />
                            <SummaryItem
                                category='ssap.income_information.summary.total_income'
                                replacements={{
                                    personName: normalizeNameOfPerson(name),
                                    coverageYear
                                }}
                                value={ helperFunctions.getIncomeValueForRender(projectedIncome, reportedIncome) }
                                ignoreIntl={true}
                            />

                            <SourcesSummary
                                { ...{
                                    applicantGuid,
                                    expenses,
                                    incomes,
                                    isState,
                                    previousData: data,
                                    reportedIncome
                                } }
                            />
                        </div>

                        { getAlert() }
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment,
    data: state.ssap.data
});

export default connect(mapStateToProps)(Page3_36_E1);
